module.exports = __webpack_public_path__ + "img/placeholder.6665fb3e.jpg";